import { render, staticRenderFns } from "./PolicyCardPage.vue?vue&type=template&id=30dfe992"
import script from "./PolicyCardPage.vue?vue&type=script&lang=js"
export * from "./PolicyCardPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports